import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { RENTAL_TYPE_VARIABLE } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/BaseCarProduct";
import { CarProduct } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/CarProduct";
import React from "react";

export const carDetailsList = (
  product: CarProduct,
  types: any,
): ProductDetail[] => {
  const displayCommercialVehicle =
    product.greenLicensePlateColor === true &&
    product.commercialVehicle === false;

  return [
    {
      name: "deductible",
      value: (
        <DeductibleValue
          value={product.priceSpecifications.deductible.code ?? "??"}
        />
      ),
    },
    {
      name: "yearlyKmNeed",
      value: getYearlyKmNeedValue(product, types),
    },
    {
      name: "rentalType",
      value: (
        <YesOrNo
          value={
            product.rentalType === RENTAL_TYPE_VARIABLE.RENTAL_TYPE_EXTENDED
          }
        />
      ),
      hidden:
        !product.rentalType || product.rentalType === RENTAL_TYPE_VARIABLE.NONE,
    },
    { name: "damageRecentYears", value: product.damageCountRecentYears ?? 0 },
    {
      name: "yearOfLastDamage",
      value: product.yearOfLastDamage,
      hidden: product.damageCountRecentYears === 0,
    },
    {
      name: "usedByYoungDriver",
      value: <YesOrNo value={product.usedByYoungerDriver} />,
    },
    {
      name: "mortgagee",
      value: <YesOrNo value={product.mortgagee} />,
    },
    {
      name: "insuranceHolderIsCarOwner",
      value: <YesOrNo value={!product.insuranceHolderIsOwner} />,
    },
    {
      name: "bonus",
      value: types.bonusLevelCode[product.bonusLevelCode],
    },
    {
      name: "driveSmart",
      value: <YesOrNo value={product.driveSmart} />,
      hidden: !product.driveSmartSupported,
    },
    {
      name: "commercialVehicle",
      value: <YesOrNo value={product.commercialVehicle} />,
      hidden: !displayCommercialVehicle,
    },
  ];
};

const getYearlyKmNeedValue = (product: CarProduct, types: any): string => {
  const agreementProduct =
    product.priceSpecifications.discount.agreementProduct;
  if (agreementProduct === 500 || agreementProduct === 501) {
    return types.yearlyKmNeed["99"];
  }
  return product.yearlyKmNeed && types.yearlyKmNeed[product.yearlyKmNeed];
};
